import { atom } from 'jotai'

import { SelectedAddon } from '@/app/[locale]/[ferry]/extras/_components/interface'
import { SelectedPet } from '@/app/[locale]/[ferry]/pets/_components/interface'

// Define the atom
export const addonsBusyAtom = atom<AddonBusy>({
  busy: false,
})

// True while a departure mutation (add/remove/date change) is in progress on the yourbooking page
export const departuresBusyAtom = atom<boolean>(false)

// True while a pet mutation is in progress on the pets page. petInFocus is the pet currently being
// committed, so the other pet counters can be disabled while it settles.
export const petsBusyAtom = atom<PetBusy>({
  busy: false,
})

export const loadingAtom = atom<LoadingState>({
  newDateLoading: false,
})

type AddonBusy = {
  addonInFocus?: SelectedAddon
  busy: boolean
}

type PetBusy = {
  petInFocus?: SelectedPet
  busy: boolean
}

export type LoadingState = {
  legNumber?: 1 | 2
  newDateLoading: boolean
}
